import { render } from "./Simulation.vue?vue&type=template&id=5aaf43ea&scoped=true"
import script from "./Simulation.vue?vue&type=script&lang=js"
export * from "./Simulation.vue?vue&type=script&lang=js"

import "./Simulation.vue?vue&type=style&index=0&id=5aaf43ea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aaf43ea"]])

export default __exports__